export const formatFipeId = (id_type) => {
  if (!id_type) return;
  if (id_type === 2) return 1;
  if (id_type === 7 || id_type === 4) return 2;
  if (id_type === 8) return 3;
  return id_type
};
